import { Component, OnInit } from '@angular/core';
import {BasicParametersComponent} from '../../basic-parameters/basic-parameters.component';
import {AlertaService} from '../../../../../../shared/services/alerta.service';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {PortalServiceFactoryService} from '../../../../services/portal-service-factory.service';

@Component({
  selector: 'app-agile-sms-basic-parameters',
  templateUrl: './agile-sms-basic-parameters.component.html',
  styleUrls: ['./agile-sms-basic-parameters.component.scss']
})
export class AgileSmsBasicParametersComponent extends BasicParametersComponent implements OnInit {

    constructor(protected fb: FormBuilder, protected portalCampFactory: PortalServiceFactoryService, protected alertHandler: AlertaService) {
        super(fb, portalCampFactory, alertHandler);

        this.form.get('area_checker').clearValidators();
        this.form.setControl('gateway', new FormControl('', Validators.required));
        this.form.setControl('type', new FormControl('', Validators.required));
        this.form.setControl('delivery', new FormControl());
    }

  ngOnInit(){
      super.ngOnInit();

      this.form.controls['gateway'].setValue(this.portalService.getConfigKey('gateway', ''));
      this.form.controls['type'].setValue(this.portalService.getConfigKey('type', ''));
      this.form.controls['delivery'].setValue(this.portalService.getConfigKey('delivery', ''));
  }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/agile_sms/agile-sms-basic-parameters/agile-sms-basic-parameters.component.ts